import React from "react";
import Text from "@/components/ui/text";
import { CheckboxGroupItem } from "@/components/ui/checkbox-group";
import { getFullName } from "@/entities/people/helpers";
import { PersonData } from "@/entities/people/types";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/utils";
import { includes, isNull } from "lodash";

interface Props {
  person: PersonData;
  selectedPeople: string[];
  handleSelectedPeopleChange: (personId: string, checked: boolean) => void;
  allDealPeople: string[] | null | undefined;
  entityName?: string;
}

const PersonCheckbox: React.FC<Props> = ({
  person,
  selectedPeople,
  handleSelectedPeopleChange,
  allDealPeople,
  entityName
}) => {
  const { t } = useTranslation();
  const isDisabled = includes(allDealPeople, person.id);
  return (
    <CheckboxGroupItem
      id={person.id}
      label={
        <>
          <div className="flex flex-col">
            <Text className={isDisabled ? "!text-disabled" : ""}>
              {getFullName(person)}
            </Text>
            {!isNull(person.jobTitle) && (
              <Text
                variant="bodySecondary"
                className={isDisabled ? "!text-disabled" : ""}
              >
                {person?.jobTitle}
              </Text>
            )}
          </div>
          {isDisabled && (
            <Text variant="bodyTertiary">
              {t("detailedView.peopleTab.involvedInDeal", { entityName })}
            </Text>
          )}
        </>
      }
      checked={includes(selectedPeople, person.id)}
      onCheckedChange={(checked: boolean) =>
        handleSelectedPeopleChange(person.id, checked)
      }
      disabled={includes(allDealPeople, person.id)}
      containerClassName={cn(
        "justify-start",
        isDisabled
          ? ""
          : "pl-[2px] pr-3 py-2 transition-colors duration-200 ease-in-out rounded hover:bg-surface-hover-soft"
      )}
      labelClassName={isDisabled ? "flex w-full justify-between" : ""}
    />
  );
};

export default PersonCheckbox;
